import { render } from "./LoginView.vue?vue&type=template&id=039c2c7e"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__